<template>
  <div>
    <!-- 外部道具结果页头部bar | 外部带货场景使用-->
    <div class="mod-live-goods-head">
      <span v-show="showClose" class="mod-live-goods-head--close" @click="closeIconAction"></span>
      <span v-show="showBack" class="mod-live-goods-head--back" @click="backIconAction"></span>
      <p class="mod-live-goods-head--title">{{ title }}</p>
      <div class="mod-live-goods-head--icon">
        <span v-if="showOrder" class="icon-l" @click="orderIconAction"></span>
        <span v-if="showQA" class="icon-r" @click="qaAction"></span>
        <span v-if="showHome" class="icon-r icon-r-style" @click="homeAction"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    iframeUrl: String,
    showOrder: {
      type: Boolean,
      default: false
    },
    showQA: {
      type: Boolean,
      default: false
    },
    qaIconAction: {
      type: Function,
      default: () => {}
    },
    showClose: {
      type: Boolean,
      default: false
    },
    closeIconAction: {
      type: Function,
      default: () => {}
    },
    showBack: {
      type: Boolean,
      default: false
    },
    backIconAction: {
      type: Function,
      default: () => {}
    },
    showHome: {
      type: Boolean,
      default: false
    },
    homeAction: {
      type: Function,
      default: () => {}
    },
    orderIconAction: {
      type: Function,
      default: () => {}
    }
  },

  methods: {
    qaAction() {
      this.qaIconAction(this.title)
    }
  }
}
</script>
